// angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
// model imports
import { DocumentTreeResultDto } from '../../shared-document-module/_models/document-tree-result-dto';
import { DocumentResultDto } from '../../shared-document-module/_models/document-result-dto';
// constant imports
import { CacheDuration } from '../../_constants/cache-duration';
import { URLConstants } from '../../_constants/url-constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class AttachmentService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    downloadFile(fileUrl) {
        return this.httpClient
            .get(fileUrl, { responseType: 'arraybuffer' })
            .pipe(map((responseData) => new Blob([responseData])));
    }
    getDocumentsTree(communityId, customerId, clearCache) {
        let url = '';
        if (!!customerId) {
            url = `${URLConstants.ccOwnerApiBaseUrl}documents/tree?customerId=${customerId}&communityId=${communityId}&clearCache=${clearCache}`;
        }
        else {
            url = `${URLConstants.ccCommunityApiBaseUrl}documents/tree?communityId=${communityId}&clearCache=${clearCache}`;
        }
        this.cacheRegistrationService.registerForCache(url, clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(DocumentTreeResultDto, responseData)));
    }
    getDocumentsList(params) {
        let url = '';
        if (!!params.customerId) {
            url = `${URLConstants.ccOwnerApiBaseUrl}documents/list${params.getQueryString()}`;
        }
        else {
            url = `${URLConstants.ccCommunityApiBaseUrl}documents/list${params.getQueryString()}`;
        }
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(DocumentResultDto, responseData)));
    }
}
AttachmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AttachmentService_Factory() { return new AttachmentService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: AttachmentService, providedIn: "root" });
